import React from 'react';
import { IconButton } from '@fiverr-private/button';
import { translate } from '@fiverr-private/i18n-react';
import { BurgerIcon } from '@fiverr-private/visuals';
import isTouchDevice from '../../../lib/isTouchDevice';
import { sendBigQueryEvent } from '../../../utils/bigQuery';
import { useHeaderContext } from '../../context/HeaderContext';
import { useLogoMakerContext } from '../../context/LogoMakerContext';

/**
 * "Opens" the sidebar by adding the appropriate class to the <body> element.
 */
const openSidebar = () => {
    document.body.classList.add('menu-shown');
};

/**
 * Reports the navicon click to BigQuery.
 * @param {Object} [user] Current user data.
 */
const report = (user) => {
    const data = {
        type: 'clicked_on_side_bar_button',
        platform: isTouchDevice() ? 'mobile_web' : 'web',
        group: 'user_actions',
        sub_group: 'website_actions',
        action: {
            type: 'click',
        },
        feature: {
            name: 'menu_side_bar',
        },
        page: {
            element_name: 'menu_side_bar',
        },
        publisher: {
            domain: 'platform',
            team: 'ants',
        },
    };

    if (user) {
        Object.assign(data, {
            user: {
                id: user.id,
            },
        });
    }

    sendBigQueryEvent(data);
};

export const NavIcon = () => {
    const { user } = useHeaderContext();
    const { isTransparent } = useLogoMakerContext();

    const handleClick = (user) => {
        report(user);
        openSidebar();
    };

    const colorScheme = isTransparent ? 'white' : undefined;

    return (
        <IconButton
            aria-label={translate<string>('header.logo_maker.sidebar_menu')}
            intent="secondary"
            variant="ghost"
            colorScheme={colorScheme}
            onClick={() => handleClick(user)}
        >
            <BurgerIcon size="md" />
        </IconButton>
    );
};
